import { render, staticRenderFns } from "./skills.vue?vue&type=template&id=c93b67f2&scoped=true"
import script from "./skills.vue?vue&type=script&lang=js"
export * from "./skills.vue?vue&type=script&lang=js"
import style0 from "./skills.vue?vue&type=style&index=0&id=c93b67f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93b67f2",
  null
  
)

export default component.exports